var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrevious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.902.89c4.935 0 8.95 4.015 8.95 8.95a.642.642 0 11-1.285 0c0-4.226-3.44-7.665-7.665-7.665-4.226 0-7.666 3.439-7.666 7.665 0 4.227 3.439 7.665 7.666 7.665a7.622 7.622 0 006.52-3.635l.051-.085c.056-.09.109-.183.16-.277a.646.646 0 01.874-.25c.31.172.422.563.25.873l-.056.102-.186.314a8.901 8.901 0 01-7.613 4.243c-4.935 0-8.95-4.015-8.95-8.95S4.967.89 9.902.89z",
    fill: "#191C26",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B65EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.276 8.766h4.177v4.844"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B65EE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.2 10.72l-2.036-2 2.036-2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/assets/previous.6737ccf4.svg";
export { ForwardRef as ReactComponent };